import type { SelectOption } from '@rio-cloud/rio-uikit/Select';
import { createElement, useMemo } from 'react';

import { useGetVehiclesQuery } from '#api/resources.slice.ts';
import { VehiclePlate } from '#components/resources/VehiclePlate.tsx';
import { getVehicleDisplayName, type Vehicle } from '#domain/Vehicle.ts';

export const useGetVehicleOptions = ({ skip = false }: { skip?: boolean } = {}) => {
    const { data: vehicles } = useGetVehiclesQuery(undefined, { skip });
    return useMemo<SelectOption[]>(
        () =>
            vehicles
                ?.slice()
                .sort(sortVehicles)
                .map(vehicle => ({
                    id: vehicle.id,
                    label: createElement(VehiclePlate, { vehicle }),
                })) || [],
        [vehicles]
    );
};

export const sortVehicles = (a: Vehicle, b: Vehicle) => {
    const aValue = getVehicleDisplayName(a);
    const bValue = getVehicleDisplayName(b);
    return aValue.localeCompare(bValue);
};
